import { z } from 'zod';
// TODO: Use common country codes as identifiers
export const I18nStringSchema = z.object({
    english: z.string(),
    spanish: z.string()
});
// For content that isn't translated everywhere yet. Consumers fall back to English via t()
export const PartialI18nStringSchema = z.object({
    english: z.string(),
    spanish: z.string().optional()
});
export const I18nStringListSchema = z.object({
    english: z.array(z.string()).optional(),
    spanish: z.array(z.string()).optional()
});
//# sourceMappingURL=i18n.js.map